import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import graphic from '../assets/images/graphic.png';

const mapStateToProps = ({ allPage }) => {
  const data = _.map(allPage, (value, key) => {
    // console.log('policy', _.find(value, page => _.get(page, 'slug') === 'policy'));
    return {
      key,
      ..._.find(value, page => _.get(page, 'slug') === 'policy'),
    };
  });
  return {
    policyData: _.keyBy(data, 'key'),
  };
};

const actions = {};

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};

class Policy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { getContentLanguage } = this.props;
    const { policyData, language } = this.props;
    const policyFiles = _.get(policyData, `${language}.acf.policy`, []);
    const bannerFiles = _.get(policyData, `${language}.acf.banner`, []);
    return (
      <div className="policy-screen">
        <div className="row no-gutters">
          {_.size(bannerFiles) > 0 && (
            <div className="banners-container">
              {_.map(bannerFiles, (item) => {
                return (
                  <div className="banner-item">
                    <img src={item.url} alt="" />
                  </div>
                );
              })}
            </div>
          )}

          <div className="col-md-3">
            <div className="graphic">
              <img src={graphic} alt="" />
            </div>
          </div>
          <div className="col-12 col-md-6 offset-md-1 m-bottom-40 content-container">
            <div className="row no-gutters">
              <div className="col-12">
                <h2 className="head darkGray m-top-20 m-bottom-20">
                  {getContentLanguage('policy')}
                </h2>
              </div>
            </div>
            {_.map(policyFiles, (item) => {
              const filePdf = _.get(item, 'pdf.url');
              return (
                <div className="row no-gutters m-bottom-10">
                  <div className="col-6">
                    <h6 className="darkGray">{item.name}</h6>
                  </div>
                  <div className="col-6">
                    <a
                      href={filePdf}
                      download={item.name}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <h6 className="lightBlue">Download PDF</h6>
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Policy);



// WEBPACK FOOTER //
// ./src/screens/Policy.js